var exports = {
  "X": "BetaLabel__12zX76",
};

module.exports = exports;
